(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecs-coverage"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-coverage]');
  if (!roots.length) return;
  roots.forEach(function(root) {
    var zones = root.querySelectorAll('.ecs-coverage__zone');
    var readout = root.querySelector('[data-readout]');
    var labelEl = root.querySelector('[data-readout-label]');
    var systemEl = root.querySelector('[data-readout-system]');
    var sqftEl = root.querySelector('[data-readout-sqft]');

    // Collect block-level zone data by reading from zone elements' text + adjacent siblings if present.
    // We expose label/system/sqft from data-* attributes on a hidden config — but simpler is to mirror
    // data into each zone's group via a sibling element. Here we read from data attributes set by liquid.
    var zoneData = Array.prototype.map.call(zones, function(z) {
      return {
        label: z.getAttribute('aria-label') || '',
        rect: z.querySelector('[data-zone-rect]'),
        innerDot: z.querySelector('[data-zone-dot-inner]'),
        outerDot: z.querySelector('[data-zone-dot-outer]'),
        pulse: z.querySelector('[data-zone-pulse]'),
        color: (z.querySelector('[data-zone-rect]') || {}).getAttribute ? z.querySelector('[data-zone-rect]').getAttribute('data-zone-color') : '#9EAD85',
        system: z.getAttribute('data-system') || '',
        sqft: z.getAttribute('data-sqft') || ''
      };
    });

    function setActive(idx) {
      zones.forEach(function(z, i) {
        var d = zoneData[i];
        if (!d.rect) return;
        if (i === idx) {
          z.classList.add('is-active');
          d.rect.setAttribute('fill', d.color);
          d.rect.setAttribute('fill-opacity', '0.35');
          d.rect.setAttribute('stroke-width', '2');
          if (d.outerDot) d.outerDot.setAttribute('r', '7');
          if (d.pulse) { d.pulse.style.display = ''; }
        } else {
          z.classList.remove('is-active');
          // restore hatch fill
          var hatchId = d.rect.closest('svg').querySelector('pattern').getAttribute('id');
          d.rect.setAttribute('fill', 'url(#' + hatchId + ')');
          d.rect.removeAttribute('fill-opacity');
          d.rect.setAttribute('stroke-width', '1');
          if (d.outerDot) d.outerDot.setAttribute('r', '5');
          if (d.pulse) { d.pulse.style.display = 'none'; }
        }
      });
      var d = zoneData[idx];
      if (d) {
        if (labelEl) labelEl.textContent = d.label.toUpperCase();
        if (systemEl) systemEl.textContent = d.system;
        if (sqftEl) sqftEl.textContent = d.sqft;
        if (readout) readout.style.borderColor = d.color;
      }
    }

    zones.forEach(function(z, i) {
      z.addEventListener('mouseenter', function() { setActive(i); });
      z.addEventListener('focus', function() { setActive(i); });
    });

    setActive(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecs-noc"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-noc]');
  if (!roots.length) return;
  var TICK_MS = 100, CYCLE_LEN = 240, TOTAL = CYCLE_LEN * 2;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var STATUS_COLOR = { ok: '#9EAD85', anomaly: '#E5C158', down: '#9E2D2D', service: '#1A2E94' };
  var STATUS_LABEL = {
    ok: 'RUNNING NORMALLY',
    anomaly: 'BEHAVIOR SHIFT — EARLY SIGNAL',
    down: 'FAILED · SCENT STOPPED',
    service: 'FIELD SERVICE ON-SITE'
  };

  function signalAt(p, good) {
    if (p < 0.20) return 100;
    if (p < 0.45) return 100 + 32 * ((p - 0.20) / 0.25);
    if (p < 0.70) {
      if (good) return 132 - 32 * ((p - 0.45) / 0.25);
      var t = (p - 0.45) / 0.10;
      if (t < 1) return 132 + 48 * t;
      return 5;
    }
    if (p < 0.95) return good ? 100 : 5;
    return 100;
  }

  function statusAt(p, good) {
    if (p < 0.20) return 'ok';
    if (p < 0.45) return good ? 'anomaly' : 'ok';
    if (p < 0.70) return good ? 'service' : 'down';
    if (p < 0.95) return good ? 'ok' : 'down';
    return good ? 'ok' : 'service';
  }

  function getNarration(good, p) {
    if (p < 0.20) return {
      title: 'Hour 0–9: Normal operation',
      body: good
        ? 'The ScentBeat System reports every 60 seconds. Dispense rate, oil level, pressure, cellular handshake — all nominal.'
        : 'The ScentBeat System is running. Nobody’s looking. Nobody needs to.'
    };
    if (p < 0.45) return {
      title: good ? 'Hour 9–21: Power draw climbs above baseline' : 'Hour 9–21: Something is changing',
      body: good
        ? 'Power consumption rises ~30% above nominal — the pump is working harder, almost always a partial nozzle clog. The NOC sees the curve cross the alert threshold and opens a ticket. No field visit yet, just attention.'
        : 'The pump is straining. Current draw is climbing. There’s no sensor reporting this to anyone. The lobby still smells fine — for now.'
    };
    if (p < 0.70) return {
      title: good ? 'Hour 21–33: Field tech preempts failure' : 'Hour 21–33: Pump overloads, then trips',
      body: good
        ? 'Service is dispatched while the device is still running. Nozzle cleared, pump returns to baseline draw. Scent never stops in the space. Guests notice nothing.'
        : 'Power draw spikes to ~180% as the pump locks against the clog, then collapses to near-zero when the protection circuit trips. The device is dead. Staff walking the floor over the next shift will notice the lobby has lost its scent — but no one is sure for how long, or who to call.'
    };
    if (p < 0.95) return {
      title: good ? 'Hour 33+: Back to normal' : 'Hour 33–46: Scent gap, ticket queued',
      body: good
        ? 'Device returns to baseline behavior. NOC closes the ticket. Total guest-visible disruption: zero hours.'
        : 'Front-of-house has flagged the dead device to facilities. A work order goes out to the scent vendor. The vendor opens a ticket the next business day. The lobby continues to smell like nothing.'
    };
    return {
      title: good ? 'Incident closed · no downtime' : 'Hour 46+: Truck rolls, finally',
      body: good
        ? 'One incident, prevented. The compliance line stays flat. Repeat 24/7/365.'
        : 'A technician arrives, replaces the cartridge. The lobby has been off-brand for ~36 hours. The next time this happens, the same thing will happen.'
    };
  }

  function computeDowntimeBad(tick) {
    var totalCycles = Math.floor(tick / CYCLE_LEN);
    var phase = (tick % CYCLE_LEN) / CYCLE_LEN;
    var inFail = phase >= 0.45 && phase < 0.95;
    var failProgress = Math.min(1, Math.max(0, (phase - 0.45) / 0.50));
    return totalCycles * 36 + (inFail ? failProgress * 36 : phase >= 0.95 ? 36 : 0);
  }

  function deviceColor(p, good) {
    if (p < 0.20) return '#9EAD85';
    if (p < 0.45) return good ? '#E5C158' : '#9EAD85';
    if (p < 0.70) return good ? '#1A2E94' : '#9E2D2D';
    if (p < 0.95) return good ? '#9EAD85' : '#9E2D2D';
    return good ? '#9EAD85' : '#1A2E94';
  }
  function serviceColor(p, good) {
    if (good) return (p >= 0.45 && p < 0.70) ? '#1A2E94' : '#F0EBE0';
    return (p >= 0.95) ? '#1A2E94' : '#F0EBE0';
  }
  function gapColor(p, good) {
    if (good) return '#F0EBE0';
    return (p >= 0.55 && p < 0.95) ? '#9E2D2D' : '#F0EBE0';
  }

  function el(tag, attrs, parent) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  roots.forEach(function(root) {
    var section = root.closest('.ecs-noc');
    var cols = root.querySelectorAll('.ecs-noc__col');
    var tick = 0, paused = false;
    var TIMELINE_SAMPLES = 80;

    // Build timeline cells once
    cols.forEach(function(col) {
      ['device', 'service', 'gap'].forEach(function(name) {
        var row = col.querySelector('[data-row="' + name + '"]');
        if (!row) return;
        for (var i = 0; i < TIMELINE_SAMPLES; i++) {
          var s = document.createElement('span');
          if ((i + 1) % (TIMELINE_SAMPLES / 2) === 0 && i < TIMELINE_SAMPLES - 1) {
            s.style.borderRight = '1px solid #fff';
          }
          row.appendChild(s);
        }
        var ph = document.createElement('div');
        ph.className = 'ecs-noc__playhead';
        row.appendChild(ph);
      });
    });

    // Build chart static elements once per column
    cols.forEach(function(col) {
      var good = col.getAttribute('data-good') === '1';
      var svg = col.querySelector('[data-chart-svg]');
      if (!svg) return;
      var W = 560, H = 200, padL = 56, padR = 16, padT = 24, padB = 36;
      var chartW = W - padL - padR;
      var chartH = H - padT - padB;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);

      var staticG = el('g', { 'data-static': '1' }, svg);

      // y-axis grid
      [0, 50, 100, 150, 200].forEach(function(v) {
        var y = padT + chartH - (v / 200) * chartH;
        el('line', { x1: padL, y1: y, x2: W - padR, y2: y, stroke: '#E5E0D3', 'stroke-width': '0.5' }, staticG);
        var t = el('text', {
          x: padL - 8, y: y + 3, 'text-anchor': 'end',
          'font-family': "'Roboto Mono', monospace", 'font-size': '8',
          fill: '#737373', 'letter-spacing': '0.06em'
        }, staticG);
        t.textContent = v + '%';
      });

      // baseline at 100%
      var y100 = padT + chartH - (100 / 200) * chartH;
      el('line', { x1: padL, y1: y100, x2: W - padR, y2: y100, stroke: '#9EAD85', 'stroke-width': '0.8', 'stroke-dasharray': '4 3' }, staticG);
      var nomLabel = el('text', { x: W - padR - 6, y: y100 - 4, 'text-anchor': 'end', 'font-family': "'Roboto Mono', monospace", 'font-size': '7', fill: '#406138', 'letter-spacing': '0.08em' }, staticG);
      nomLabel.textContent = 'NOMINAL';

      // y-axis label
      var yAxis = el('text', {
        x: padL - 44, y: padT + chartH / 2,
        'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373',
        'letter-spacing': '0.12em', 'text-anchor': 'middle',
        transform: 'rotate(-90, ' + (padL - 44) + ', ' + (padT + chartH / 2) + ')'
      }, staticG);
      yAxis.textContent = 'POWER DRAW';

      // x-axis hour labels
      [0, 12, 24, 36, 48].forEach(function(h, i) {
        var x = padL + (i / 4) * chartW;
        var t = el('text', { x: x, y: H - 12, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373', 'letter-spacing': '0.08em' }, staticG);
        t.textContent = h + 'h';
      });

      // GOOD: alert threshold band
      if (good) {
        el('rect', {
          x: padL, y: padT + chartH - (145 / 200) * chartH,
          width: chartW, height: (45 / 200) * chartH,
          fill: '#E5C158', 'fill-opacity': '0.14'
        }, staticG);
        el('line', {
          x1: padL, y1: padT + chartH - (120 / 200) * chartH,
          x2: W - padR, y2: padT + chartH - (120 / 200) * chartH,
          stroke: '#E5C158', 'stroke-width': '0.8', 'stroke-dasharray': '3 3'
        }, staticG);
        var thr = el('text', {
          x: W - padR - 6, y: padT + chartH - (120 / 200) * chartH - 4,
          'text-anchor': 'end', 'font-family': "'Roboto Mono', monospace",
          'font-size': '7', fill: '#A8862E', 'letter-spacing': '0.08em'
        }, staticG);
        thr.textContent = 'ALERT THRESHOLD · 120%';
      }

      // full faded path
      var pts = [];
      for (var i = 0; i < 120; i++) {
        var p = i / 119;
        var v = signalAt(p, good);
        pts.push([padL + p * chartW, padT + chartH - (v / 200) * chartH]);
      }
      var fullPath = pts.map(function(pt, i) { return (i === 0 ? 'M' : 'L') + ' ' + pt[0] + ' ' + pt[1]; }).join(' ');
      el('path', {
        d: fullPath, fill: 'none',
        stroke: good ? '#9EAD85' : '#CFCABC',
        'stroke-width': '1', 'stroke-dasharray': '2 3',
        opacity: good ? '0.3' : '0.45'
      }, staticG);

      // dynamic layer
      var dyn = el('g', { 'data-dyn': '1' }, svg);
      col.__nocPts = pts;
      col.__nocDims = { W: W, H: H, padL: padL, padR: padR, padT: padT, padB: padB, chartW: chartW, chartH: chartH };
    });

    function renderCol(col, t) {
      var good = col.getAttribute('data-good') === '1';
      var phasePct = (t % CYCLE_LEN) / CYCLE_LEN;
      var cycleIdx = Math.floor(t / CYCLE_LEN);
      var status = statusAt(phasePct, good);
      var nar = getNarration(good, phasePct);

      // narrator
      var nt = col.querySelector('[data-narrator-title]');
      var nb = col.querySelector('[data-narrator-body]');
      if (nt) nt.textContent = nar.title;
      if (nb) nb.textContent = nar.body;

      // status chip
      var chip = col.querySelector('[data-chart-status]');
      if (chip) {
        chip.textContent = STATUS_LABEL[status];
        chip.style.background = STATUS_COLOR[status];
        chip.style.color = status === 'anomaly' ? '#141414' : '#fff';
      }

      // uptime
      var downtime = good ? 0 : computeDowntimeBad(t);
      var uptime = good ? 100 : Math.max(0, 100 - (downtime / (TOTAL / 10)) * 100);
      var uptimeEl = col.querySelector('[data-uptime]');
      if (uptimeEl) uptimeEl.textContent = uptime.toFixed(1) + '%';

      // scent gap label (bad column)
      var gap = col.querySelector('[data-scent-gap]');
      if (gap && !good) gap.textContent = downtime.toFixed(0) + ' hr scent gap';

      // chart dynamic layer
      var svg = col.querySelector('[data-chart-svg]');
      if (svg) {
        var dyn = svg.querySelector('[data-dyn="1"]');
        if (dyn) {
          dyn.innerHTML = '';
          var dims = col.__nocDims;
          var pts = col.__nocPts;

          // visible path
          var visibleCount = Math.max(1, Math.floor(phasePct * 119));
          var visPath = pts.slice(0, visibleCount + 1).map(function(pt, i) { return (i === 0 ? 'M' : 'L') + ' ' + pt[0] + ' ' + pt[1]; }).join(' ');
          dyn.appendChild(el('path', {
            d: visPath, fill: 'none',
            stroke: good ? '#1A1A1A' : '#9E2D2D',
            'stroke-width': '1.8',
            'stroke-linejoin': 'round', 'stroke-linecap': 'round'
          }));

          // GOOD anomaly marker at 0.30
          if (good && phasePct >= 0.30) {
            var ax = dims.padL + 0.30 * dims.chartW;
            var ay = dims.padT + dims.chartH - (signalAt(0.30, good) / 100) * dims.chartH;
            dyn.appendChild(el('circle', { cx: ax, cy: ay, r: '5', fill: '#E5C158', stroke: '#1A1A1A', 'stroke-width': '1.2' }));
            dyn.appendChild(el('line', { x1: ax, y1: ay - 8, x2: ax, y2: dims.padT + 4, stroke: '#1A1A1A', 'stroke-width': '0.6', 'stroke-dasharray': '2 2' }));
            dyn.appendChild(el('rect', { x: ax - 60, y: dims.padT - 4, width: '120', height: '14', fill: '#1A1A1A' }));
            var anomLab = el('text', { x: ax, y: dims.padT + 6, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#fff', 'letter-spacing': '0.1em', 'font-weight': '700' });
            anomLab.textContent = 'ANOMALY DETECTED';
            dyn.appendChild(anomLab);
          }

          // GOOD service window band
          if (good && phasePct >= 0.45) {
            var bandW = Math.min(0.25, phasePct - 0.45) * dims.chartW;
            dyn.appendChild(el('rect', {
              x: dims.padL + 0.45 * dims.chartW, y: dims.padT,
              width: bandW, height: dims.chartH,
              fill: '#1A2E94', 'fill-opacity': '0.08'
            }));
          }

          // BAD failure band
          if (!good && phasePct >= 0.55) {
            var badW = Math.min(0.5, phasePct - 0.45) * dims.chartW;
            dyn.appendChild(el('rect', {
              x: dims.padL + 0.45 * dims.chartW, y: dims.padT,
              width: badW, height: dims.chartH,
              fill: '#9E2D2D', 'fill-opacity': '0.10'
            }));
            if (phasePct >= 0.85) {
              var cx = dims.padL + 0.55 * dims.chartW;
              dyn.appendChild(el('rect', { x: cx - 60, y: dims.padT - 4, width: '120', height: '14', fill: '#9E2D2D' }));
              var gcl = el('text', { x: cx, y: dims.padT + 6, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#fff', 'letter-spacing': '0.1em', 'font-weight': '700' });
              gcl.textContent = 'GUEST COMPLAINT FILED';
              dyn.appendChild(gcl);
            }
          }

          // playhead
          var phx = dims.padL + phasePct * dims.chartW;
          var phv = signalAt(phasePct, good);
          var phy = dims.padT + dims.chartH - (phv / 200) * dims.chartH;
          dyn.appendChild(el('line', { x1: phx, y1: dims.padT, x2: phx, y2: dims.padT + dims.chartH, stroke: '#1A1A1A', 'stroke-width': '1' }));
          dyn.appendChild(el('circle', { cx: phx, cy: phy, r: '4', fill: '#1A1A1A' }));
          dyn.appendChild(el('circle', { cx: phx, cy: phy, r: '2', fill: '#fff' }));

          // BAD visibility curtain
          if (!good) {
            dyn.appendChild(el('rect', {
              x: dims.padL, y: dims.padT,
              width: dims.chartW * 0.45, height: dims.chartH,
              fill: '#FAFAF7', 'fill-opacity': '0.85'
            }));
            var nt1 = el('text', { x: dims.padL + dims.chartW * 0.225, y: dims.padT + dims.chartH / 2 - 4, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#9E2D2D', 'letter-spacing': '0.16em', 'font-weight': '700' });
            nt1.textContent = 'NO TELEMETRY';
            dyn.appendChild(nt1);
            var nt2 = el('text', { x: dims.padL + dims.chartW * 0.225, y: dims.padT + dims.chartH / 2 + 10, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373', 'letter-spacing': '0.08em' });
            nt2.textContent = 'Behavior is invisible until something breaks';
            dyn.appendChild(nt2);
          }
        }
      }

      // timeline rows
      ['device', 'service', 'gap'].forEach(function(name) {
        var row = col.querySelector('[data-row="' + name + '"]');
        if (!row) return;
        var cells = row.children;
        for (var i = 0; i < TIMELINE_SAMPLES; i++) {
          var cell = cells[i];
          if (!cell || cell.tagName !== 'SPAN') continue;
          var tickPos = (i / TIMELINE_SAMPLES) * TOTAL;
          var p = (tickPos % CYCLE_LEN) / CYCLE_LEN;
          var color;
          if (name === 'device') color = deviceColor(p, good);
          else if (name === 'service') color = serviceColor(p, good);
          else color = gapColor(p, good);
          cell.style.background = color;
        }
        var ph = row.querySelector('.ecs-noc__playhead');
        if (ph) ph.style.left = ((t / TOTAL) * 100) + '%';
      });

      // counter (only update once)
      if (col.getAttribute('data-good') === '1') {
        var counter = section.querySelector('[data-counter]');
        if (counter) counter.textContent = 'Cycle ' + (cycleIdx + 1) + ' of 2 · ' + Math.round((t / TOTAL) * 100) + '%';
      }
    }

    function frame() { cols.forEach(function(c) { renderCol(c, tick); }); }

    var interval = null;
    function start() {
      if (interval) return;
      interval = setInterval(function() { tick = (tick + 1) % TOTAL; frame(); }, TICK_MS);
    }
    function stop() { if (interval) { clearInterval(interval); interval = null; } }

    var toggle = section.querySelector('[data-toggle]');
    var restart = section.querySelector('[data-restart]');
    if (toggle) toggle.addEventListener('click', function() {
      paused = !paused;
      if (paused) { stop(); toggle.textContent = '▶ Play'; }
      else { start(); toggle.textContent = '⏸ Pause'; }
    });
    if (restart) restart.addEventListener('click', function() { tick = 0; frame(); });

    frame();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting && !paused) start();
          else stop();
        });
      }, { threshold: 0.1 });
      io.observe(section);
    } else { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ecs-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var el = document.querySelector('[data-ecs-sticky]');
  if (!el) return;
  el.removeAttribute('hidden');
  function update() {
    var y = window.scrollY;
    var v = y > 720 && y < (document.body.scrollHeight - 1100);
    el.setAttribute('data-visible', v ? '1' : '0');
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pou-cold-air"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-coldair]');
  if (!roots.length) return;
  var TICK_MS = 100, CYCLE_LEN = 320, TOTAL = 320;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var STATUS_COLOR = { intact: '#1A1A1A', drifting: '#E5C158', collapsed: '#9E2D2D' };
  var STATUS_LABEL = { intact: 'PROFILE INTACT', drifting: 'TOP NOTES DEGRADING', collapsed: 'PROFILE COLLAPSED' };

  function intensityAt(good, p) {
    if (good) {
      if (p < 0.95) return 100;
      return 100 - (p - 0.95) * 200;
    }
    if (p < 0.10) return 100 - p * 60;
    if (p < 0.40) return 94 - (p - 0.10) * 100;
    if (p < 0.80) return 64 - (p - 0.40) * 80;
    return 32 - (p - 0.80) * 80;
  }
  function statusAt(good, p) {
    if (good) return 'intact';
    if (p < 0.15) return 'intact';
    if (p < 0.60) return 'drifting';
    return 'collapsed';
  }
  function getNarration(good, p) {
    if (p < 0.10) return {
      title: 'Hour 0–200: Bottle profile',
      body: good
        ? 'Cartridge ships at 100% fidelity. Atomized at room temperature into sub-micron droplets — the same chemical profile the perfumer signed off on.'
        : 'The candle warmer is still warm. The reed sticks are still wet. The space smells like the bottle — for now.'
    };
    if (p < 0.40) return {
      title: good ? 'Hour 200–800: No drift' : 'Hour 200–800: Top notes burning off',
      body: good
        ? 'Power-modulated piezo atomization holds the dispense rate constant. No heat, no air-pressure dependency — the curve is flat by design.'
        : 'Bergamot, citrus, ozonic — anything volatile is the first to evaporate under heat. The space starts smelling less bright, more flat, even though the cartridge looks full.'
    };
    if (p < 0.70) return {
      title: good ? 'Hour 800–1,400: Mid-cartridge fidelity check' : 'Hour 800–1,400: Mid notes thinning',
      body: good
        ? 'Internal pump telemetry reports profile drift at ≤0.2% — within instrumentation noise. Guests can’t tell hour 1 from hour 1,200.'
        : 'Floral and herbal mid notes are next to go — they’re more delicate than the base resins. The fragrance starts to smell one-dimensional: only the heavy base notes remain.'
    };
    if (p < 0.95) return {
      title: good ? 'Hour 1,400–1,900: Continued nominal' : 'Hour 1,400–1,900: Down to base notes only',
      body: good
        ? 'Still 100% nominal. The cartridge is over 70% depleted by volume, but the chemistry hasn’t drifted because the molecules didn’t see heat or water.'
        : 'The room now smells like amber and musk — generic, heavy, vaguely “warm”. Nothing identifiable. The candle warmer is half-empty and the reeds went dry weeks ago.'
    };
    return {
      title: good ? 'Hour 1,900–2,000: Cartridge depleting' : 'Hour 1,900+: Profile collapsed',
      body: good
        ? 'Gentle taper as the reservoir empties. Replace cartridge; new cycle starts at 100%. Same profile, same fidelity.'
        : 'Whatever started as a curated fragrance is now ambient warmth. The patchwork failed before the volume did — and that’s the failure mode point-source has had since 1972.'
    };
  }

  var GHOST_METHODS = [
    { name: 'heat warmer', fn: function(p) { return Math.max(0, 100 - p * 110); } },
    { name: 'reed sticks', fn: function(p) { return Math.max(0, 70 - p * 50); } },
    { name: 'gel beads', fn: function(p) { return Math.max(0, 90 - p * 80); } },
    { name: 'aerosol', fn: function(p) { return 35 + 35 * Math.sin(p * 22) - p * 25; } }
  ];

  var NOTE_LAYERS = [
    { label: 'TOP', desc: 'bergamot, citrus, ozonic — burn off first under heat', color: '#E5C158', r: 32, decay: function(good, p) { return good ? 1 : Math.max(0.05, 1 - p * 1.6); } },
    { label: 'MID', desc: 'florals, herbal, spice — the body of the scent', color: '#1A1A1A', r: 22, decay: function(good, p) { return good ? 1 : Math.max(0.20, 1 - p * 1.1); } },
    { label: 'BASE', desc: 'musk, amber, wood — outlive the other notes', color: '#7A613D', r: 12, decay: function(good, p) { return good ? 1 : Math.max(0.60, 1 - p * 0.45); } }
  ];

  function el(tag, attrs, parent) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  roots.forEach(function(root) {
    var section = root.closest('.pou-coldair');
    var cols = root.querySelectorAll('.pou-coldair__col');
    var tick = 0, paused = false;

    // Build static chart + fingerprint elements once per column
    cols.forEach(function(col) {
      var good = col.getAttribute('data-good') === '1';

      // ----- chart -----
      var svg = col.querySelector('[data-chart-svg]');
      var W = 560, H = 200, padL = 56, padR = 16, padT = 24, padB = 36;
      var chartW = W - padL - padR, chartH = H - padT - padB;
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var cs = el('g', { 'data-static': '1' }, svg);

      [0, 25, 50, 75, 100].forEach(function(v) {
        var y = padT + chartH - (v / 110) * chartH;
        el('line', { x1: padL, y1: y, x2: W - padR, y2: y, stroke: '#E5E0D3', 'stroke-width': '0.5' }, cs);
        var t = el('text', { x: padL - 8, y: y + 3, 'text-anchor': 'end', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373', 'letter-spacing': '0.06em' }, cs);
        t.textContent = v + '%';
      });
      var yNom = padT + chartH - (100 / 110) * chartH;
      el('line', { x1: padL, y1: yNom, x2: W - padR, y2: yNom, stroke: '#A8862E', 'stroke-width': '0.8', 'stroke-dasharray': '4 3' }, cs);
      var nomT = el('text', { x: W - padR - 6, y: yNom - 4, 'text-anchor': 'end', 'font-family': "'Roboto Mono', monospace", 'font-size': '7', fill: '#A8862E', 'letter-spacing': '0.08em' }, cs);
      nomT.textContent = 'NOMINAL (BOTTLE)';
      var yAx = el('text', { x: padL - 44, y: padT + chartH / 2, 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373', 'letter-spacing': '0.12em', 'text-anchor': 'middle', transform: 'rotate(-90, ' + (padL - 44) + ', ' + (padT + chartH / 2) + ')' }, cs);
      yAx.textContent = 'SCENT FIDELITY';
      [0, 500, 1000, 1500, 2000].forEach(function(h, i) {
        var x = padL + (i / 4) * chartW;
        var t = el('text', { x: x, y: H - 12, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#737373', 'letter-spacing': '0.08em' }, cs);
        t.textContent = h.toLocaleString() + 'h';
      });

      // ghost method lines (bad only)
      if (!good) {
        GHOST_METHODS.forEach(function(m, mi) {
          var pts = [];
          for (var i = 0; i < 60; i++) {
            var p = i / 59;
            var v = Math.max(0, Math.min(110, m.fn(p)));
            pts.push((padL + p * chartW) + ',' + (padT + chartH - (v / 110) * chartH));
          }
          el('polyline', { points: pts.join(' '), fill: 'none', stroke: '#9E2D2D', 'stroke-width': '0.6', 'stroke-dasharray': '2 3', opacity: '0.35' }, cs);
          var lt = el('text', { x: W - padR - 6, y: padT + 16 + mi * 10, 'text-anchor': 'end', 'font-family': "'Roboto Mono', monospace", 'font-size': '7', fill: '#9E2D2D', 'letter-spacing': '0.08em', opacity: '0.7' }, cs);
          lt.textContent = '· ' + m.name;
        });
      }

      // full faded path
      var fpts = [];
      for (var i = 0; i < 120; i++) {
        var p = i / 119;
        var v = intensityAt(good, p);
        fpts.push([padL + p * chartW, padT + chartH - (Math.max(0, v) / 110) * chartH]);
      }
      var fullPath = fpts.map(function(pt, i) { return (i === 0 ? 'M' : 'L') + ' ' + pt[0] + ' ' + pt[1]; }).join(' ');
      el('path', { d: fullPath, fill: 'none', stroke: good ? '#1A1A1A' : '#CFCABC', 'stroke-width': '1', 'stroke-dasharray': '2 3', opacity: good ? '0.3' : '0.45' }, cs);

      // good stable band
      if (good) {
        el('rect', { x: padL, y: padT + chartH - (105 / 110) * chartH, width: chartW, height: (15 / 110) * chartH, fill: '#E5C158', 'fill-opacity': '0.12' }, cs);
      }

      el('g', { 'data-dyn': '1' }, svg);
      col.__caChart = { svg: svg, pts: fpts, W: W, H: H, padL: padL, padR: padR, padT: padT, padB: padB, chartW: chartW, chartH: chartH };

      // ----- fingerprint -----
      var fp = col.querySelector('[data-fp-svg]');
      var FW = 560, FH = 84, fcx = 60, fcy = FH / 2 - 2;
      fp.setAttribute('viewBox', '0 0 ' + FW + ' ' + FH);
      var fps = el('g', { 'data-static': '1' }, fp);
      NOTE_LAYERS.forEach(function(layer) {
        el('circle', { cx: fcx, cy: fcy, r: layer.r, fill: 'none', stroke: layer.color, 'stroke-width': '1', 'stroke-dasharray': '2 3', opacity: '0.35' }, fps);
      });
      NOTE_LAYERS.forEach(function(layer, i) {
        var g = el('g', { transform: 'translate(130, ' + (10 + i * 22) + ')' }, fps);
        el('rect', { x: '0', y: '-7', width: '10', height: '10', fill: layer.color }, g);
        var lbl = el('text', { x: '18', y: '2', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#141414', 'letter-spacing': '0.08em', 'font-weight': '700' }, g);
        lbl.textContent = layer.label;
        var desc = el('text', { x: '56', y: '2', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#595959', 'letter-spacing': '0.02em' }, g);
        desc.textContent = layer.desc;
        var pct = el('text', { x: String(FW - 80), y: '2', 'text-anchor': 'start', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: layer.color, 'letter-spacing': '0.06em', 'font-weight': '700', 'data-note-pct': i }, g);
        pct.textContent = '100%';
      });
      el('g', { 'data-dyn': '1' }, fp);
      col.__caFp = { svg: fp, cx: fcx, cy: fcy };
    });

    function renderCol(col, t) {
      var good = col.getAttribute('data-good') === '1';
      var phasePct = (t % CYCLE_LEN) / CYCLE_LEN;
      var status = statusAt(good, phasePct);
      var intensity = Math.max(0, intensityAt(good, phasePct));
      var nar = getNarration(good, phasePct);

      // fidelity badge
      var fidelity = col.querySelector('[data-fidelity]');
      if (fidelity) {
        fidelity.textContent = Math.max(0, Math.round(intensity)) + '%';
        if (!good) fidelity.style.color = intensity > 60 ? '#A8862E' : '#9E2D2D';
      }

      // status chip
      var chip = col.querySelector('[data-status]');
      if (chip) {
        chip.textContent = STATUS_LABEL[status];
        chip.style.background = STATUS_COLOR[status];
        chip.style.color = status === 'drifting' ? '#141414' : '#fff';
      }

      // narrator
      var nt = col.querySelector('[data-narrator-title]');
      var nb = col.querySelector('[data-narrator-body]');
      if (nt) nt.textContent = nar.title;
      if (nb) nb.textContent = nar.body;

      // chart dynamic layer
      var ch = col.__caChart;
      var dyn = ch.svg.querySelector('[data-dyn="1"]');
      dyn.innerHTML = '';
      var visibleCount = Math.max(1, Math.floor(phasePct * 119));
      var visPath = ch.pts.slice(0, visibleCount + 1).map(function(pt, i) { return (i === 0 ? 'M' : 'L') + ' ' + pt[0] + ' ' + pt[1]; }).join(' ');
      dyn.appendChild(el('path', { d: visPath, fill: 'none', stroke: good ? '#1A1A1A' : '#9E2D2D', 'stroke-width': '1.8', 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }));
      // bad collapse band
      if (!good && phasePct >= 0.60) {
        dyn.appendChild(el('rect', { x: ch.padL + 0.60 * ch.chartW, y: ch.padT, width: (phasePct - 0.60) * ch.chartW, height: ch.chartH, fill: '#9E2D2D', 'fill-opacity': '0.07' }));
      }
      // playhead
      var phx = ch.padL + phasePct * ch.chartW;
      var phy = ch.padT + ch.chartH - (intensity / 110) * ch.chartH;
      dyn.appendChild(el('line', { x1: phx, y1: ch.padT, x2: phx, y2: ch.padT + ch.chartH, stroke: '#1A1A1A', 'stroke-width': '1' }));
      dyn.appendChild(el('circle', { cx: phx, cy: phy, r: '4', fill: '#1A1A1A' }));
      dyn.appendChild(el('circle', { cx: phx, cy: phy, r: '2', fill: '#fff' }));

      // fingerprint dynamic layer
      var fp = col.__caFp;
      var fdyn = fp.svg.querySelector('[data-dyn="1"]');
      fdyn.innerHTML = '';
      NOTE_LAYERS.forEach(function(layer, i) {
        var amt = layer.decay(good, phasePct);
        var circ = 2 * Math.PI * layer.r;
        fdyn.appendChild(el('circle', {
          cx: fp.cx, cy: fp.cy, r: layer.r, fill: 'none',
          stroke: layer.color, 'stroke-width': '2.2',
          'stroke-dasharray': (circ * amt) + ' ' + circ,
          transform: 'rotate(-90, ' + fp.cx + ', ' + fp.cy + ')'
        }));
        var pctEl = fp.svg.querySelector('[data-note-pct="' + i + '"]');
        if (pctEl) pctEl.textContent = Math.round(amt * 100) + '%';
      });
      var fpPct = col.querySelector('[data-fp-pct]');
      if (fpPct) fpPct.textContent = good ? 'ALL NOTES PRESENT' : (Math.round((1 - phasePct * 0.9) * 100) + '% OF ORIGINAL');
    }

    function frame() {
      cols.forEach(function(c) { renderCol(c, tick); });
      var counter = section.querySelector('[data-counter]');
      if (counter) {
        var hour = Math.round((tick / CYCLE_LEN) * 2000);
        counter.textContent = 'Hour ' + hour.toLocaleString() + ' of 2,000 · ' + Math.round((tick / TOTAL) * 100) + '%';
      }
    }

    var interval = null;
    function start() {
      if (interval) return;
      interval = setInterval(function() { tick = (tick + 1) % TOTAL; frame(); }, TICK_MS);
    }
    function stop() { if (interval) { clearInterval(interval); interval = null; } }

    var toggle = section.querySelector('[data-toggle]');
    var restart = section.querySelector('[data-restart]');
    if (toggle) toggle.addEventListener('click', function() {
      paused = !paused;
      if (paused) { stop(); toggle.textContent = '▶ Play'; }
      else { start(); toggle.textContent = '⏸ Pause'; }
    });
    if (restart) restart.addEventListener('click', function() { tick = 0; frame(); });

    frame();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting && !paused) start();
          else stop();
        });
      }, { threshold: 0.1 });
      io.observe(section);
    } else { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pou-coverage"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-coverage]');
  if (!roots.length) return;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function el(tag, attrs, parent) {
    var n = document.createElementNS(SVG_NS, tag);
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function fmt(n) { return n >= 1000 ? (n / 1000).toFixed(1).replace('.0', '') + 'k' : String(n); }

  roots.forEach(function(root) {
    var svg = root.querySelector('[data-coverage-svg]');
    var items = Array.prototype.map.call(root.querySelectorAll('.pou-coverage__data li'), function(li) {
      return {
        name: li.getAttribute('data-name'),
        short: li.getAttribute('data-short'),
        min: parseFloat(li.getAttribute('data-min')) || 100,
        max: parseFloat(li.getAttribute('data-max')) || 1000,
        color: li.getAttribute('data-color') || '#E5C158'
      };
    });
    if (!items.length) return;

    // examples: "label:sqft, label:sqft"
    var examples = [];
    var exRaw = root.getAttribute('data-examples') || '';
    exRaw.split(',').forEach(function(pair) {
      var bits = pair.split(':');
      if (bits.length === 2) examples.push({ label: bits[0].trim(), sqft: parseFloat(bits[1]) || 0 });
    });

    var W = 760, H = 240, padL = 80, padR = 40, padT = 60, padB = 60;
    var chartW = W - padL - padR, chartH = H - padT - padB;
    var minLog = Math.log10(100), maxLog = Math.log10(10000);
    function toX(sqft) {
      var v = Math.max(100, Math.min(10000, sqft));
      return padL + ((Math.log10(v) - minLog) / (maxLog - minLog)) * chartW;
    }

    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);

    // axis gridlines + tick labels
    [100, 200, 500, 1000, 2000, 5000, 10000].forEach(function(tick) {
      var x = toX(tick);
      el('line', { x1: x, y1: padT - 6, x2: x, y2: H - padB + 6, stroke: '#E5E0D3', 'stroke-width': '0.5' }, svg);
      var t = el('text', { x: x, y: H - padB + 22, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#737373', 'letter-spacing': '0.06em' }, svg);
      t.textContent = tick >= 1000 ? (tick / 1000) + 'k' : tick;
    });
    var axisLabel = el('text', { x: W / 2, y: H - 10, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#595959', 'letter-spacing': '0.14em' }, svg);
    axisLabel.textContent = 'SQ FT COVERAGE';

    // example markers along the top
    examples.forEach(function(ex) {
      var x = toX(ex.sqft);
      el('line', { x1: x, y1: padT - 4, x2: x, y2: padT + chartH + 4, stroke: '#1A1A1A', 'stroke-width': '0.4', 'stroke-dasharray': '2 3', opacity: '0.3' }, svg);
      var lbl = el('text', { x: x, y: padT - 18, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#595959', 'letter-spacing': '0.06em' }, svg);
      lbl.textContent = ex.label;
      var amt = el('text', { x: x, y: padT - 8, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '8', fill: '#A8862E', 'letter-spacing': '0.04em', 'font-weight': '700' }, svg);
      amt.textContent = '~' + fmt(ex.sqft) + ' sq ft';
    });

    // system bars
    var bars = [];
    items.forEach(function(sys, i) {
      var x1 = toX(sys.min), x2 = toX(sys.max);
      var y = padT + i * 24;
      var g = el('g', { style: 'cursor:pointer' }, svg);
      var rect = el('rect', { x: x1, y: y - 8, width: Math.max(2, x2 - x1), height: 16, fill: sys.color, 'fill-opacity': '0.45', stroke: '#1A1A1A', 'stroke-width': '0.4' }, g);
      var c1 = el('circle', { cx: x1, cy: y, r: '2.5', fill: '#1A1A1A' }, g);
      var c2 = el('circle', { cx: x2, cy: y, r: '2.5', fill: '#1A1A1A' }, g);
      var nameT = el('text', { x: padL - 12, y: y + 3, 'text-anchor': 'end', 'font-family': "Futura, 'Century Gothic', sans-serif", 'font-size': '12', 'font-weight': '500', fill: '#595959', 'letter-spacing': '-0.01em' }, g);
      nameT.textContent = sys.name;
      var rangeT = el('text', { x: (x1 + x2) / 2, y: y + 3, 'text-anchor': 'middle', 'font-family': "'Roboto Mono', monospace", 'font-size': '9', fill: '#595959', 'letter-spacing': '0.04em', 'font-weight': '500' }, g);
      rangeT.setAttribute('pointer-events', 'none');
      rangeT.textContent = sys.min + '–' + fmt(sys.max) + ' sq ft';
      bars.push({ g: g, rect: rect, c1: c1, c2: c2, nameT: nameT, rangeT: rangeT, sys: sys });
      g.addEventListener('mouseenter', function() { setActive(i); });
    });

    var readout = root.querySelector('[data-readout]');
    var rShort = root.querySelector('[data-readout-short]');
    var rName = root.querySelector('[data-readout-name]');
    var rRange = root.querySelector('[data-readout-range]');

    function setActive(idx) {
      bars.forEach(function(b, i) {
        var on = i === idx;
        b.rect.setAttribute('fill-opacity', on ? '0.85' : '0.45');
        b.rect.setAttribute('stroke-width', on ? '1' : '0.4');
        b.c1.setAttribute('r', on ? '4' : '2.5');
        b.c2.setAttribute('r', on ? '4' : '2.5');
        b.nameT.setAttribute('fill', on ? '#141414' : '#595959');
        b.nameT.setAttribute('font-size', on ? '14' : '12');
        b.rangeT.setAttribute('fill', on ? '#141414' : '#595959');
      });
      var s = items[idx];
      if (rShort) rShort.textContent = (s.short || '').toUpperCase();
      if (rName) rName.textContent = s.name;
      if (rRange) rRange.textContent = s.min + '–' + fmt(s.max) + ' sq ft';
      if (readout) readout.style.borderColor = s.color;
    }

    // default active = middle item
    setActive(Math.floor(items.length / 2));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pou-systems"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-systems]');
  if (!roots.length) return;
  roots.forEach(function(root) {
    var tabs = root.querySelectorAll('.pou-systems__tab');
    var panels = root.querySelectorAll('.pou-systems__card');
    var rows = root.querySelectorAll('.pou-systems__grid-row');

    function activate(idx) {
      tabs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
      panels.forEach(function(p, i) { p.classList.toggle('is-active', i === idx); });
      rows.forEach(function(r, i) { r.classList.toggle('is-active', i === idx); });
    }

    tabs.forEach(function(t, i) {
      t.addEventListener('click', function() { activate(i); });
    });
    rows.forEach(function(r, i) {
      r.addEventListener('click', function() {
        activate(i);
        root.querySelector('.pou-systems__tabs').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-fan-sync"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-fansync]');
  if (!roots.length) return;
  var TICK_MS = 80, CYCLE_LEN = 48, FAN_ON_LEN = 28, TOTAL = CYCLE_LEN * 5;
  var SVG_NS = 'http://www.w3.org/2000/svg';

  var BLADE_PATHS = [];
  for (var bi = 0; bi < 12; bi++) {
    var a = (bi / 12) * 360;
    var rad = function(d) { return d * Math.PI / 180; };
    var qx = Math.cos(rad(a - 15)) * 16;
    var qy = Math.sin(rad(a - 15)) * 16;
    var ex = Math.cos(rad(a)) * 26;
    var ey = Math.sin(rad(a)) * 26;
    BLADE_PATHS.push('M 0 0 Q ' + qx.toFixed(2) + ' ' + qy.toFixed(2) + ' ' + ex.toFixed(2) + ' ' + ey.toFixed(2));
  }

  roots.forEach(function(root) {
    var section = root.closest('.wh-fansync');
    var paused = false;
    var tick = 0;
    var cols = root.querySelectorAll('.wh-fansync__col');

    cols.forEach(function(col) {
      var blades = col.querySelectorAll('[data-fan-blade]');
      blades.forEach(function(b) {
        var i = parseInt(b.getAttribute('data-blade-i'), 10) || 0;
        b.setAttribute('d', BLADE_PATHS[i]);
      });
    });

    cols.forEach(function(col) {
      ['fan', 'scent', 'waste'].forEach(function(name) {
        var row = col.querySelector('[data-row="' + name + '"]');
        if (!row) return;
        for (var i = 0; i < TOTAL; i++) row.appendChild(document.createElement('span'));
        var ph = document.createElement('div');
        ph.className = 'wh-fansync__playhead';
        row.appendChild(ph);
      });
    });

    function el(tag, attrs) {
      var n = document.createElementNS(SVG_NS, tag);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    function renderCol(col, t) {
      var good = col.getAttribute('data-good') === '1';
      var side = good ? 'good' : 'bad';
      var uid = root.getAttribute('data-fansync');
      var glow = 'url(#scent-glow-' + side + '-' + uid + ')';
      var arrow = 'url(#af-' + side + '-' + uid + ')';

      var cyclePhase = t % CYCLE_LEN;
      var fanOn = cyclePhase < FAN_ON_LEN;
      var cycleIdx = Math.floor(t / CYCLE_LEN);
      var progress = t / TOTAL;

      var goodDrain = progress * 12;
      var badDrain = progress * 20;
      var cartridge = good ? (100 - goodDrain) : (100 - badDrain);
      var delivered = good ? goodDrain : badDrain * 0.58;
      var wasted = good ? 0 : badDrain * 0.42;

      var fanGroup = col.querySelector('[data-fan-group]');
      var fanCircle = col.querySelector('[data-fan-circle]');
      var fanLabel = col.querySelector('[data-fan-label]');
      var fanBadge = col.querySelector('[data-fan-badge]');
      var fanBadgeText = col.querySelector('[data-fan-badge-text]');
      var fanBlades = col.querySelectorAll('[data-fan-blade]');
      if (fanGroup) fanGroup.setAttribute('transform', 'rotate(' + (fanOn ? t * 9 : 0) + ')');
      if (fanCircle) fanCircle.setAttribute('fill', '#0F0F0E');
      fanBlades.forEach(function(b) { b.setAttribute('stroke', fanOn ? '#9EAD85' : '#5C5444'); });
      if (fanLabel) {
        fanLabel.textContent = fanOn ? 'RUNNING' : 'IDLE';
        fanLabel.setAttribute('fill', fanOn ? '#406138' : '#9E2D2D');
      }
      if (fanBadge) fanBadge.setAttribute('fill', fanOn ? '#1A1A1A' : '#E0D1B8');
      if (fanBadgeText) {
        fanBadgeText.setAttribute('fill', fanOn ? '#fff' : '#737373');
        fanBadgeText.textContent = fanOn ? 'FAN ON' : 'FAN IDLE';
      }

      var cartLiquid = col.querySelector('[data-cart-liquid]');
      var cartLabel = col.querySelector('[data-cart-label]');
      if (cartLiquid) {
        var dy = (100 - cartridge) * 0.32;
        cartLiquid.setAttribute('y', String(6 + dy));
        cartLiquid.setAttribute('height', String(Math.max(0, 32 - dy)));
      }
      if (cartLabel) {
        cartLabel.textContent = Math.round(cartridge) + '%';
        cartLabel.setAttribute('fill', cartridge > 90 ? '#141414' : (good ? '#406138' : '#9E2D2D'));
      }

      var relayLight = col.querySelector('[data-relay-light]');
      if (relayLight) relayLight.setAttribute('fill', (good && fanOn) ? '#9EAD85' : '#3A3A38');

      var airflow = col.querySelector('[data-airflow]');
      if (airflow) {
        airflow.innerHTML = '';
        if (fanOn) {
          for (var i = 0; i < 8; i++) {
            var off = (t * 4 + i * 45) % 360;
            var x = 100 + off;
            var y = 100 + ((i % 3) - 1) * 18;
            var op = Math.min(1, off / 30) * Math.min(1, (360 - off) / 30) * 0.7;
            airflow.appendChild(el('line', {
              x1: String(x - 14), y1: String(y), x2: String(x), y2: String(y),
              stroke: '#9EAD85', 'stroke-width': '1.4',
              'marker-end': arrow, opacity: String(op)
            }));
          }
        }
      }

      var dropLayer = col.querySelector('[data-drops]');
      if (dropLayer) {
        dropLayer.innerHTML = '';
        if (good && fanOn) {
          for (var i = 0; i < 7; i++) {
            var birth = (i / 7) * FAN_ON_LEN;
            var age = cyclePhase - birth;
            if (age < 0 || age > FAN_ON_LEN - birth) continue;
            var travel = age / FAN_ON_LEN;
            var x = 260 + travel * 110;
            if (x > 378) continue;
            var wave = Math.sin(travel * Math.PI * 2 + i) * 4;
            var y = 100 + wave;
            var op = Math.max(0, 0.95 - travel * 0.3);
            var r = 3.2 - travel * 0.6;
            dropLayer.appendChild(el('circle', { cx: String(x), cy: String(y), r: String(r * 2.4), fill: glow, opacity: String(op * 0.55) }));
            dropLayer.appendChild(el('circle', { cx: String(x), cy: String(y), r: String(r), fill: '#1A2E94', opacity: String(op) }));
            dropLayer.appendChild(el('circle', { cx: String(x - 9), cy: String(y - 1.5), r: String(r * 0.55), fill: '#1A2E94', opacity: String(op * 0.4) }));
          }
        }
        if (!good) {
          for (var j = 0; j < 10; j++) {
            var birth2 = (j * 4) % CYCLE_LEN;
            var age2 = (cyclePhase - birth2 + CYCLE_LEN) % CYCLE_LEN;
            if (age2 > 22) continue;
            var bornFanOn = birth2 < FAN_ON_LEN;
            if (bornFanOn && age2 < (FAN_ON_LEN - birth2)) {
              var travel2 = age2 / 18;
              var xx = 260 + travel2 * 110;
              if (xx > 378) continue;
              dropLayer.appendChild(el('circle', { cx: String(xx), cy: String(100 + Math.sin(travel2 * 4) * 3), r: '2.5', fill: '#1A2E94', opacity: String(Math.max(0, 0.85 - travel2 * 0.5)) }));
            } else {
              var fallAge = Math.min(20, age2);
              var yy = 76 + (fallAge / 20) * 90;
              dropLayer.appendChild(el('circle', { cx: '260', cy: String(yy), r: '2.8', fill: '#1A2E94', opacity: '0.9' }));
              if (fallAge > 17) {
                dropLayer.appendChild(el('ellipse', { cx: '260', cy: '170', rx: String(6 + (fallAge - 17) * 2), ry: '1.2', fill: '#1A2E94', opacity: '0.4' }));
              }
            }
          }
        }
      }

      var poolLayer = col.querySelector('[data-pool]');
      if (poolLayer) {
        poolLayer.innerHTML = '';
      }

      ['fan', 'scent', 'waste'].forEach(function(name) {
        var row = col.querySelector('[data-row="' + name + '"]');
        if (!row) return;
        var cells = row.children;
        for (var i = 0; i < TOTAL; i++) {
          var on = false, onColor = '#1A1A1A', offColor = '#E0D1B8';
          if (name === 'fan') {
            on = (i % CYCLE_LEN) < FAN_ON_LEN;
          } else if (name === 'scent') {
            on = good ? ((i % CYCLE_LEN) < FAN_ON_LEN) : true;
            onColor = '#1A2E94'; offColor = '#F0EBE0';
          } else {
            on = !good && ((i % CYCLE_LEN) >= FAN_ON_LEN);
            onColor = '#9E2D2D'; offColor = '#F0EBE0';
          }
          var cell = cells[i];
          if (cell && cell.tagName === 'SPAN') cell.style.background = on ? onColor : offColor;
        }
        var playhead = row.querySelector('.wh-fansync__playhead');
        if (playhead) playhead.style.left = ((t / TOTAL) * 100) + '%';
      });

      var deliveredEl = col.querySelector('[data-delivered]');
      if (deliveredEl) deliveredEl.textContent = delivered.toFixed(1) + '%';
    }

    function frame() { cols.forEach(function(c) { renderCol(c, tick); }); }

    var interval = null;
    function start() {
      if (interval) return;
      interval = setInterval(function() { tick = (tick + 1) % TOTAL; frame(); }, TICK_MS);
    }
    function stop() { if (interval) { clearInterval(interval); interval = null; } }

    frame();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting && !paused) start();
          else stop();
        });
      }, { threshold: 0.1 });
      io.observe(section);
    } else {
      start();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sticky = document.querySelector('[data-sticky-cta]');
  if (!sticky) return;
  sticky.removeAttribute('hidden');
  function update() {
    var y = window.scrollY;
    var visible = y > 680 && y < (document.body.scrollHeight - 900);
    sticky.setAttribute('data-visible', visible ? '1' : '0');
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
